import { BaseCloseButton } from "../base-close-button"
import { SiteHeader } from "../site-header"
import { PokerstarsLogo } from "./pokerstars-logo"

export function PokerstarsBaseHeader() {
  return (
    <SiteHeader>
      <PokerstarsLogo />
      <BaseCloseButton />
    </SiteHeader>
  )
}
